module.exports = __webpack_public_path__ + "assets/img/edit-02.b98f00b0.svg";